import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MwButton from "../ui/MwButton";
import { getUOMById } from "../../store/weightSlice";
import { AiOutlineArrowRight, AiOutlineDelete } from "react-icons/ai";
import { MdOutlineEdit } from "react-icons/md";
import { useDelete } from "../../hooks";
import DeleteConfirmationModal from "../OsRequisition/RequisitionComponents/DeleteConfirmationModal";
import { MwSpinner } from "../ui";
import { useTranslation } from "react-i18next";
 
const OsUnitDetails = ({ id, setMode }) => {
    const dispatch = useDispatch();
      const { t, i18n } = useTranslation('global');
        const isRTL = i18n.dir() === 'rtl';
    const { deleteItem, loading: deleteLoading } = useDelete();
    const { uomByIdData, loading, error } = useSelector((state) => state.weight);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    useEffect(() => {
        dispatch(getUOMById(id));
    }, [dispatch, id]);

    const handleDelete = () => {
        setDeleteModalOpen(true);
    };

    const handleBack = () => {
        setMode('List');
    };

    const handleConfirmDelete = () => {
        deleteItem(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/inventory/uom/${id}`)
            .then(() => {
                setDeleteModalOpen(false);
                setMode('List');
            })
            .catch((error) => {
                console.error("Error deleting unit:", error);
            });
    };

    const handleEdit = () => {
        setMode('Edit');
    };

    if (loading) return  <div className="h-32 flex justify-center items-center">
    <MwSpinner />
  </div>;
    if (error) return <p className="text-center text-red-500">حدث خطأ: {error}</p>;
    if (!uomByIdData || !uomByIdData.data) return <p className="text-center">الوحدة غير موجودة...</p>;

    const { uom_master } = uomByIdData.data;

    return (
        <div className="h-[50vh] overflow-y-auto  rounded-xl custom-scrollbar bg-gray-50 p-6">
            <div className="max-w-6xl mx-auto  ">
                {/* Header Actions */}
                <div className="flex justify-end items-center">
                    
                    <MwButton
                            actionType="button"
                            size="sm"
                            inGroup={true}
                            type={isRTL? "original-right"  : "original-left"}
                            onClick={handleEdit}
                        >
                            <MdOutlineEdit className="ml-1" />
                            تعديل
                        </MwButton>
                        <MwButton
                            actionType="button"
                            size="sm"
                            inGroup={true}
                            type="deleteBtn"
                            onClick={handleDelete}
                        >
                            <AiOutlineDelete className="ml-1" />
                            حذف
                        </MwButton>
                      
                  
                </div>

                {/* Title */}
                <h5 className="text-xl mb-4 font-semibold text-center text-gray-600">
                    {uomByIdData?.data?.name}
                </h5>

                {/* Main Info Table */}
                <div className="bg-white rounded-lg shadow-sm mb-3">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="px-6 py-3 text-right text-xs font-semibold text-gray-700">{t('Warehouse_settings.Field')}</th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-gray-700">{t('Warehouse_settings.Value')}</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            <tr className="hover:bg-gray-50">
                                <td className="px-6 py-4 text-xs text-gray-600">   {t('Warehouse_settings.Unit Name')}</td>
                                <td className="px-6 py-4 text-xs text-gray-900">{uom_master?.name}</td>
                            </tr>
                            <tr className="hover:bg-gray-50">
                                <td className="px-6 py-4 text-xs text-gray-600"> {t('Warehouse_settings.Short Name')}  </td>
                                <td className="px-6 py-4 text-xs text-gray-900">{uom_master?.short_name}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Details Table */}
                <div className="bg-white rounded-lg shadow-sm">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="px-6 py-3 text-right text-xs font-semibold text-gray-700"> {t('Warehouse_settings.Unit Name')}  </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-gray-700"> {t('Warehouse_settings.Conversion Factor')}  </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-gray-700"> {t('Warehouse_settings.Short Name')}  </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {uom_master?.uom_details?.length > 0 ? (
                                uom_master.uom_details.map((detail, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 text-xs text-gray-900">{detail.name}</td>
                                        <td className="px-6 py-4 text-xs text-gray-900">{detail.rate}</td>
                                        <td className="px-6 py-4 text-xs text-gray-900">{detail.short_name}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="px-6 py-4 text-sm text-center text-gray-500">
                                    {t('Warehouse_settings.No details for the units')}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <DeleteConfirmationModal
                isOpen={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleConfirmDelete}
                loading={deleteLoading}
            />
        </div>
    );
};

export default OsUnitDetails;